<!-- TOP Nav Bar -->
<div class="iq-top-navbar header-top-sticky">
  <div class="iq-navbar-custom">
    <nav class="navbar navbar-expand-lg  p-0">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <i class="ri-menu-3-line"></i>
      </button>
      <div class="iq-menu-bt align-self-center">
        <div class="wrapper-menu" role="button" tabindex="0" aria-label="Toggle navigation menu"
          (keydown.enter)="$any($event.target).click()" (keydown.space)="$event.preventDefault(); $any($event.target).click()">
          <div class="main-circle"><i class="ri-menu-3-line"></i></div>
          <div class="hover-circle"><i class="ri-close-line"></i></div>
        </div>
      </div>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto navbar-list">
          <li class="nav-item" (click)="openDialog()">
            <a class="search-toggle iq-waves-effect cp">
              <i class="fa fa-share-square-o"></i>
            </a>
          </li>
          <li class="nav-item">
            <a class="search-toggle iq-waves-effect cp"  (click)="openDrop()">
              <i class="fa fa-bell-o"></i>
              <span class="badgedot dots" *ngIf="unReadCount > 0"><h2 class="ffhfhfhf">{{unReadCount}}</h2></span>
            </a>
            <div class="DropDv" *ngIf="isOpen">
              <div class="iq-card shadow-none m-0">
                <div class="iq-card-body p-0">
                  <div class="bg-primary p-3">
                    <h5 class="mb-0 text-white">
                      All Notifications
                      <!-- <small class="badge  badge-light float-right pt-1" *ngIf="notificaitons">{{ notificaitons.length }}</small> -->
                    </h5>
                  </div>
                  <div class="bodyDv">
                  <p class="fffffDv"  *ngIf="!notificaitons">No Notifications Found !</p>
                  <ng-container *ngIf="notificaitons">
                    <a class="iq-sub-card" *ngFor="let item of notificaitons">
                      <div class="media align-items-center InfoDv" (click)="goToDetail(item)">
                        <div class="" *ngIf="item && item.data">
                          <img class="avatar-40 rounded" *ngIf="item.data.photoUrl" [src]="item.data.photoUrl" alt="">
                          <img class="avatar-40 rounded" *ngIf="!item.data.photoUrl" src="../../../assets/images_v2/bg-03.jpg" alt="">
                        </div>
                        <div class="media-body ml-3" *ngIf="item && item.data">
                          <h6 class="mb-0 head01">{{ item.data.title  }}</h6>
                          <p class="mb-0 head02">{{ item.data.body }}</p>
                          <small class="float-right font-size-12">{{ item.createdOn | date }}</small>
                        </div>
                      </div>
                    </a>
                  </ng-container>
                  </div>
                  <ul class="paginationDv" (click)="seeMore()" *ngIf="showSeeMore && notificaitons &&  notificaitons.length > 4">
                    <li><p>See More</p></li>
                  </ul>
                 </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <ul class="navbar-list">
        <li class="nav-item">
          <div class="down_icon"></div>
        </li>
      </ul>
      <ul class="navbar-list">
        <li>
          <a class="search-toggle iq-waves-effect d-flex align-items-center cp">
            <div class="caption">
              <h6 class="mb-0 line-height text-white">{{this.user.firstName}} {{this.user.lastName}}</h6>
            </div>
            <img [src]="this.user.photoUrl" class="img-fluid rounded ml-3" alt="user">
          </a>
          <div class="iq-sub-dropdown iq-user-dropdown">
            <div class="iq-card shadow-none m-0">
              <div class="iq-card-body p-0 ">
                <div class="bg-primary p-3">
                  <h5 class="mb-0 text-white line-height">Hello {{this.user.firstName}}
                    {{this.user.lastName}}</h5>
                  <!-- <span class="text-white font-size-12">Available</span> -->
                </div>
                <!-- <a routerLink="/account/profile" class="iq-sub-card iq-bg-primary-hover">
                  <div class="media align-items-center">
                    <div class="rounded iq-card-icon iq-bg-primary">
                      <i class="ri-file-user-line"></i>
                    </div>
                    <div class="media-body ml-3">
                      <h6 class="mb-0 ">My Profile</h6>
                      <p class="mb-0 font-size-12">View personal profile details.</p>
                    </div>
                  </div>
                </a> -->
                <a routerLink="/account/profile" class="iq-sub-card iq-bg-primary-hover">
                  <div class="media align-items-center">
                    <div class="rounded iq-card-icon iq-bg-primary">
                      <i class="ri-profile-line"></i>
                    </div>
                    <div class="media-body ml-3">
                      <h6 class="mb-0 ">Edit Profile</h6>
                      <p class="mb-0 font-size-12">Modify your personal details.</p>
                    </div>
                  </div>
                </a>
                <a routerLink="/account/change-password" class="iq-sub-card iq-bg-primary-hover">
                  <div class="media align-items-center">
                    <div class="rounded iq-card-icon iq-bg-primary">
                      <i class="ri-lock-password-line"></i>
                    </div>
                    <div class="media-body ml-3">
                      <h6 class="mb-0 ">Change Password</h6>
                      <p class="mb-0 font-size-12">Change your account password.</p>
                    </div>
                  </div>
                </a>
                <!-- <a routerLink="/account/settings" class="iq-sub-card iq-bg-primary-hover">
                  <div class="media align-items-center">
                    <div class="rounded iq-card-icon iq-bg-primary">
                      <i class="ri-account-box-line"></i>
                    </div>
                    <div class="media-body ml-3">
                      <h6 class="mb-0 ">Account settings</h6>
                      <p class="mb-0 font-size-12">Manage your account parameters.</p>
                    </div>
                  </div>
                </a> -->
                <!-- <a routerLink="/account/settings" class="iq-sub-card iq-bg-primary-hover">
                  <div class="media align-items-center">
                    <div class="rounded iq-card-icon iq-bg-primary">
                      <i class="ri-lock-line"></i>
                    </div>
                    <div class="media-body ml-3">
                      <h6 class="mb-0 ">Privacy Settings</h6>
                      <p class="mb-0 font-size-12">Control your privacy parameters.</p>
                    </div>
                  </div>
                </a> -->
                <div class="d-inline-block w-100 text-center p-3">
                  <button type="button" class="bg-primary iq-sign-btn" (click)="logout()">
                    Log out<i class="ri-login-box-line ml-2"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </nav>
  </div>
</div>
